import { render, staticRenderFns } from "./order-query.vue?vue&type=template&id=5aeafedc&scoped=true&"
import script from "./order-query.vue?vue&type=script&lang=js&"
export * from "./order-query.vue?vue&type=script&lang=js&"
import style0 from "./order-query.vue?vue&type=style&index=0&id=5aeafedc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeafedc",
  null
  
)

export default component.exports